import { render } from "./NotificationAlarmBellSvgrepoCom1.vue?vue&type=template&id=2b288d17"
import script from "./NotificationAlarmBellSvgrepoCom1.vue?vue&type=script&lang=js"
export * from "./NotificationAlarmBellSvgrepoCom1.vue?vue&type=script&lang=js"

import "./NotificationAlarmBellSvgrepoCom1.vue?vue&type=style&index=0&id=2b288d17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__